export const RECAPTCHA_SITEKEY = '6LfWCoQaAAAAAPsJ5kDsGlaB4SWesCg0MajGhEkT';
export const DEV_RECAPTCHA_SITEKEY = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';

export const getRecaptchaKey = () => {
  if (
    ['localhost:3003', 'localhost:3001', 'localhost:3000', '127.0.0.1:3003', '127.0.0.1:5000'].includes(
      window.location.host
    )
  ) {
    return DEV_RECAPTCHA_SITEKEY;
  }

  return RECAPTCHA_SITEKEY;
};
